/**
 * AddCreditsAction — the one "Add Credits" action (suite contract 1.2,
 * CREDITS pass Part 1), for out-of-credits notices.
 *
 *   may manage billing  → "Add Credits": Central's credits page for the CURRENT
 *                         workspace, return_to = this page (useCentralBillingLinks)
 *   anyone else         → "Ask your workspace owner to add credits." — no button
 *
 * Central owns packages, prices, checkout and granting; BeHeard only links.
 * Fails closed: before boot (or with no store) the user is treated as a member.
 */

import { useCentralBillingLinks } from '../../hooks/useCentralBillingLinks';
import { openCentralBilling } from '../../services/centralBillingUrls';
import { showBillingFallbackToast } from './billingToasts';

export const ASK_OWNER_CREDITS_COPY = 'Ask your workspace owner to add credits.';

export function AddCreditsAction({ className = '' }: { className?: string }) {
  const { canManage, urlFor } = useCentralBillingLinks();

  if (!canManage) {
    return (
      <p className={`text-sm text-gray-600 ${className}`} data-testid="add-credits-ask-owner">
        {ASK_OWNER_CREDITS_COPY}
      </p>
    );
  }

  const onAddCredits = () => {
    const url = urlFor('credits');
    if (url) openCentralBilling(url);
    else showBillingFallbackToast(null);
  };

  return (
    <button type="button" onClick={onAddCredits} className={`btn-primary ${className}`} data-testid="add-credits-button">
      Add Credits
    </button>
  );
}
